import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ANONYMOUS_SUBSCRIBE_URL, KNOWN_SUBSCRIBE_URL, ACTIVITY_UPDATE_URL, SOCIAL_ADD_URL, SOCIAL_REMOVE_URL } from './_constants';
/**
 * Calls API for anonymous subscribe.
 * @param {Newsletter} newsletter The newsletter to subscribe to.
 * @param {string} email The email address to subscribe.
 * @returns {Promise} A promise to handle success or failure from caller. 
 */

export var anonymousSubscribe = function anonymousSubscribe(newsletter, email, zipCode, languagePreference, enableExpandedFields, sourceCode) {
  if (!newsletter || !newsletter.listId) {
    return Promise.reject(new Error());
  }

  var requestParams = {
    newsletterGuid: newsletter.listId,
    email: email
  };

  if (enableExpandedFields) {
    requestParams.zipCode = zipCode;
    requestParams.languagePreference = languagePreference;
  }

  var updateCode = 0; // Attempt to update program activity before subscription call - pass current code back for analytics call

  return activityUpdate(sourceCode).then(function (update) {
    updateCode = update.currentSourceCode || 0;
    return fetch(ANONYMOUS_SUBSCRIBE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache',
      body: JSON.stringify(requestParams)
    });
  }).then(function (response) {
    if (!response.ok) throw Error(response.statusText);
    return response.json();
  }).then(function (data) {
    data.updateCode = updateCode;
    return data;
  });
};
export var knownSubscribe = function knownSubscribe(newsletter, sourceCode) {
  if (!newsletter || !newsletter.listId) {
    return Promise.reject(new Error());
  }

  var requestParams = {
    newsletterGuid: newsletter.listId
  };
  var updateCode = 0; // Attempt to update program activity before subscription call - pass current code back for analytics call

  return activityUpdate(sourceCode).then(function (update) {
    updateCode = update.currentSourceCode || 0;
    return fetch(KNOWN_SUBSCRIBE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache',
      body: JSON.stringify(requestParams)
    });
  }).then(function (response) {
    if (!response.ok) throw Error(response.statusText);
    response.updateCode = updateCode;
    return response;
  });
};
export var activityUpdate = function activityUpdate(sourceCode) {
  if (!sourceCode || sourceCode === 0) {
    // If code is zero, immediately return an empty object (will later resolve update code to 0)
    return Promise.resolve({});
  }

  var requestParams = {
    updateSourceCode: sourceCode
  };
  return fetch(ACTIVITY_UPDATE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    cache: 'no-cache',
    body: JSON.stringify(requestParams)
  }).then(function (response) {
    // Don't stop processing, just return an empty object as above
    if (!response.ok) return {};
    return response.json();
  });
};
export var addSocialReference = function addSocialReference(providerType, accessToken, idToken, antiForgeryFormTokenHeaderName, antiForgeryFormTokenValue) {
  if (providerType === undefined || providerType === null) {
    return Promise.reject(new Error());
  }

  var requestParams = {
    providerType: providerType,
    accessToken: accessToken,
    idToken: idToken
  };
  return fetch(SOCIAL_ADD_URL, {
    method: 'POST',
    headers: _defineProperty({
      'Content-Type': 'application/json'
    }, antiForgeryFormTokenHeaderName, antiForgeryFormTokenValue),
    cache: 'no-cache',
    body: JSON.stringify(requestParams)
  }).then(function (response) {
    if (!response.ok) throw Error(response.statusText);
    return response.json();
  });
};
export var removeSocialReference = function removeSocialReference(providerType, antiForgeryFormTokenHeaderName, antiForgeryFormTokenValue) {
  if (providerType === undefined || providerType === null) {
    return Promise.reject(new Error());
  }

  var requestParams = {
    providerType: providerType
  };
  return fetch(SOCIAL_REMOVE_URL, {
    method: 'POST',
    headers: _defineProperty({
      'Content-Type': 'application/json'
    }, antiForgeryFormTokenHeaderName, antiForgeryFormTokenValue),
    cache: 'no-cache',
    body: JSON.stringify(requestParams)
  }).then(function (response) {
    if (!response.ok) throw Error(response.statusText);
    return response;
  });
};